/*
 * Copyright © 2018-2023, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { ReactElement, useState } from "react";
import { notificationType, strings } from "../../../common/Strings/Strings";
import Button from "../../../components/Button";
import { NotificationType } from "../../../models/notification/NotificationType";
import NotificationPreviewModal from "./NotificationPreviewModal";

export default function NotificationTemplatesSection(): ReactElement {
  const [isModalVisible, setModalVisible] = useState<boolean>(false);
  const [selectedType, setSelectedType] = useState<NotificationType>();

  const openPreviewModal = (type: NotificationType) => {
    setSelectedType(type);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <div className="flex flex-col items-center mt-4">
        <div className="tw-table-container">
          <table className="tw-table">
            <thead className="tw-thead">
              <tr>
                <th className="tw-th">{strings.notification}</th>
              </tr>
            </thead>
            <tbody className="tw-tbody">
              {Object.values(NotificationType).map((type) => (
                <tr key={type}>
                  <td className="px-4 py-4 text-sm whitespace-nowrap">
                    <Button variant="link" onClick={() => openPreviewModal(type)} className="tw-link-dark">
                      {notificationType[type]}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {selectedType && <NotificationPreviewModal close={closeModal} isVisible={isModalVisible} type={selectedType} />}
    </>
  );
}
